import React from 'react';

const LinkedInIcon = (props) => (
  <svg {...props} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.22222 20H17.7778C19.0051 20 20 19.0051 20 17.7778V2.22222C20 0.994923 19.0051 0 17.7778 0H2.22222C0.994923 0 0 0.994923 0 2.22222V17.7778C0 19.0051 0.994923 20 2.22222 20Z'
      fill='#007EBB'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.2223 17.2222H14.2544V12.1672C14.2544 10.7813 13.7278 10.0068 12.6308 10.0068C11.4374 10.0068 10.814 10.8128 10.814 12.1672V17.2222H7.95376V7.59259H10.814V8.8897C10.814 8.8897 11.674 7.29839 13.7174 7.29839C15.76 7.29839 17.2223 8.54568 17.2223 11.1253V17.2222ZM4.54154 6.33166C3.56729 6.33166 2.77783 5.53601 2.77783 4.55472C2.77783 3.57343 3.56729 2.77777 4.54154 2.77777C5.51579 2.77777 6.30478 3.57343 6.30478 4.55472C6.30478 5.53601 5.51579 6.33166 4.54154 6.33166ZM3.06465 17.2222H6.04711V7.59259H3.06465V17.2222Z'
      fill='white'
    />
  </svg>
);

export default LinkedInIcon;
